/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineIdFolders202,
  PostApiV1ClassroomdisciplineIdFolders400,
  PostApiV1ClassroomdisciplineIdFolders401,
  PostApiV1ClassroomdisciplineIdFolders404,
  PostApiV1ClassroomdisciplineIdFoldersMutationRequest,
  PostApiV1ClassroomdisciplineIdFoldersMutationResponse,
  PostApiV1ClassroomdisciplineIdFoldersPathParams,
} from "../../types/classPlanningMaterialController/PostApiV1ClassroomdisciplineIdFolders.ts";
import { upsertClassroomDisFolderViewModelSchema } from "../upsertClassroomDisFolderViewModelSchema.ts";

export const postApiV1ClassroomdisciplineIdFoldersPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1ClassroomdisciplineIdFoldersPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ClassroomdisciplineIdFolders202Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdFolders202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ClassroomdisciplineIdFolders400Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdFolders400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineIdFolders401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdFolders401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassroomdisciplineIdFolders404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdFolders404>;

export const postApiV1ClassroomdisciplineIdFoldersMutationRequestSchema =
  z.lazy(
    () => upsertClassroomDisFolderViewModelSchema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdFoldersMutationRequest>;

export const postApiV1ClassroomdisciplineIdFoldersMutationResponseSchema =
  z.lazy(
    () => postApiV1ClassroomdisciplineIdFolders202Schema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdFoldersMutationResponse>;
